import { jsxs as e, jsx as c } from "react/jsx-runtime";
import { E as v, S as _ } from "./icons.types-0722eef5.js";
function u({ title: a, titleId: i, size: h, width: s, height: t, extended: r = !1, ...n }) {
  const l = r ? v : _, g = h ? l[h] : s || l[r ? "s" : "l"], o = h ? l[h] : t || l[r ? "s" : "l"];
  return /* @__PURE__ */ e(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: g,
      height: o,
      "aria-labelledby": i,
      ...n,
      children: [
        a ? /* @__PURE__ */ c("title", { id: i, children: a }) : null,
        /* @__PURE__ */ c("g", { clipPath: "url(#Charge_status__Charging_svg__a)", children: /* @__PURE__ */ c(
          "path",
          {
            fill: "currentColor",
            d: "m41.202 43.101-8.618 12.263c-.72.895-2.195.305-2.058-.824l2.041-11.34h-4.053a1.08 1.08 0 0 1-.884-1.701l8.618-12.263c.72-.895 2.195-.305 2.058.824l-2.14 11.34h4.152c.875 0 1.386.985.884 1.701ZM25.2 25.02c2.408 0 4.8.842 6.579 2.33l-2.08 2.99c-1.214-.97-2.777-1.54-4.5-1.54-3.96 0-7.2 3.24-7.2 7.2v28.62h-3.6v-28.8c0-5.94 4.86-10.8 10.8-10.8Zm36-7.02v10.8c0 3.96-3.24 7.2-7.2 7.2v18c0 5.94-4.86 10.8-10.8 10.8-3.525 0-6.558-1.737-8.56-4.304l2.231-3.173C38.06 59.596 40.42 61.2 43.2 61.2c3.96 0 7.2-3.24 7.2-7.2V36c-3.96 0-7.2-3.24-7.2-7.2V18h3.6V7.2c1.98 0 3.6 1.62 3.6 3.6V18H54v-7.2c0-1.98 1.62-3.6 3.6-3.6V18h3.6Zm-3.6 3.6H46.8v7.2c0 1.98 1.62 3.6 3.6 3.6H54c1.98 0 3.6-1.62 3.6-3.6v-7.2Z"
          }
        ) }),
        /* @__PURE__ */ c("defs", { children: /* @__PURE__ */ c("clipPath", { id: "Charge_status__Charging_svg__a", children: /* @__PURE__ */ c(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h72v72H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  u as ChargeStatusCharging
};
